import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithGmail_1 from '../../../../../libraries/Images/createAConnectionWithGmail_1.png';
import createAConnectionWithGmail_2 from '../../../../../libraries/Images/createAConnectionWithGmail_2.png';
import createAConnectionWithGmail_3 from '../../../../../libraries/Images/createAConnectionWithGmail_3.png';
import createAConnectionWithGmail_4 from '../../../../../libraries/Images/createAConnectionWithGmail_4.png';
import createAConnectionWithGmail_5 from '../../../../../libraries/Images/createAConnectionWithGmail_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithgmail">
                1.&nbsp;{translate('createaconnectionwithgmail')}
            </Typography>
            <p>接続を作成するように"新規追加"ボタンをクリック</p>
            <Zoom>
                <img src={createAConnectionWithGmail_1} width="75%" />
            </Zoom>
            <p>連携できるアプリの一覧が表示されるので、その中から「Gmail」を選択します。</p>
            <Zoom>
                <img src={createAConnectionWithGmail_2} width="75%" />
            </Zoom>
            <p>「Gmail」をクリックすると、ユーザーのGoogleアカウント選択画面が表示されます。接続に使用するアカウントを選択してください。</p>
            <Zoom>
                <img src={createAConnectionWithGmail_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>アカウントを選択すると、「RPA CLOUD」がユーザーに代わってアクセスを要求します。 「RPA CLOUD」に上記のアクセス権限を付与することに同意し、「許可」をクリックします。</p>
            <Zoom>
                <img src={createAConnectionWithGmail_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>接続が正常に作成されると、Gmail カードが表示されます。</p>
            <Zoom>
                <img src={createAConnectionWithGmail_5} width="50%"/>
            </Zoom>
            <p>このタグに含まれる<strong>プロバイダ ID</strong> を使用して、Gmailに関する機能を実行します。</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);